module.exports = __webpack_public_path__ + "static/media/pontos.ed9e9710.svg";